import { CacheLookupPolicy } from '@azure/msal-browser';

/**
 * Cache lookup policy for every `acquireTokenSilent` call in the app: use the cached access token or the
 * refresh token, but never MSAL's hidden-iframe renewal.
 *
 * msal-browser 5 only accepts a hidden-iframe result through its redirect bridge, i.e. a redirect page that
 * calls `broadcastResponseToMainFrame()` from `@azure/msal-browser/redirect-bridge`. Our redirect URI is the
 * SPA itself and never does that, so every iframe renewal runs a complete B2C sign-in (MFA step included,
 * counted by the MFA service), then times out after 10 s and is discarded. Callers retry in the background
 * until Azure throttles the user ("Phone verification request is throttled"), after which no sign-in works
 * for hours. With this policy an expired refresh token fails immediately and without any B2C traffic; the
 * MsalInterceptor then performs one top-frame redirect, which B2C answers from its session.
 *
 * Remove once the app serves a redirect-bridge page (see auth.msal.ts).
 */
export const SILENT_TOKEN_CACHE_LOOKUP_POLICY = CacheLookupPolicy.AccessTokenAndRefreshToken;
